<template>
  <!-- hero-section -->
  <div class="hero-section-third">
      <div class="container">
          <div class="row">
              <div class="offset-xl-1 col-xl-10 offset-lg-1 col-lg-10 col-md-12 col-sm-12 col-12">
                  <!-- search-block -->
                  <div class="">
                      <div class="text-center search-head">
                          <h1 class="search-head-title text-white">尋找最好的婚禮服務商戶</h1>
                          <p class="d-none d-xl-block d-lg-block d-sm-block text-white">Browse the best wedding vendors in your area — from venues and photographers, to wedding planners, caterers, florists and more.</p>
                      </div>
                      <!-- /.search-block -->
                      <!-- search-form -->
                      <div class="search-form">
                          <form class="form-row">
                              <div class="col-xl-5 col-lg-4 col-md-4 col-sm-12 col-12">
                                  <!-- select -->
                                  <select class="wide">
                                      <option value="Venue Type">Vendor Type</option>
                                      <option value="Venue">Venue</option>
                                      <option value="Florist">Florist</option>
                                      <option value="Cake">Cake</option>
                                      <option value="Photographer">Photographer</option>
                                      <option value="Catering">Catering</option>
                                      <option value="Dress">Dress</option>
                                  </select>
                              </div>
                              <div class="col-xl-5 col-lg-4 col-md-4 col-sm-12 col-12">
                                  <!-- select -->
                                  <select class="wide">
                                      <option value="Ahmedabad" data-display="Ahmedabad">Ahmedabad</option>
                                      <option value="Surat">Surat</option>
                                      <option value="Rajkot">Rajkot</option>
                                      <option value="Vadodara">Vadodara</option>
                                      <option value="Vapi">Vapi</option>
                                      <option value="Bhavnagar">Bhavnagar</option>
                                  </select>
                              </div>
                              <!-- button -->
                              <div class="col-xl-2 col-lg-4 col-md-4 col-sm-12 col-12">
                                  <button class="btn btn-default btn-block" type="submit">Search</button>
                              </div>
                          </form>
                      </div>
                      <!-- /.search-form -->
                  </div>
              </div>
          </div>
      </div>
      <div class="feature-section">
          <div class="container">
              <div class="row">
                  <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                      <div class="feature-left">
                          <div class="feature-icon">
                              <i class="fas fa-clipboard-list"></i>
                          </div>
                          <div class="feature-content">
                              <h3 class="text-white mb-1">13000+</h3>
                              <p class="text-white">Vendor Listing</p>
                          </div>
                      </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                      <div class="feature-left">
                          <div class="feature-icon">
                              <i class="fas fa-smile"></i>
                          </div>
                          <div class="feature-content">
                              <h3 class="text-white mb-1">12000+</h3>
                              <p class="text-white">Happy Users</p>
                          </div>
                      </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                      <div class="feature-left">
                          <div class="feature-icon">
                              <i class="fas fa-map-marker-alt"></i>
                          </div>
                          <div class="feature-content">
                              <h3 class="text-white mb-1">168+</h3>
                              <p class="text-white">Worldwide Cities</p>
                          </div>
                      </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                      <div class="feature-left">
                          <div class="feature-icon">
                              <i class="fas fa-heart"></i>
                          </div>
                          <div class="feature-content">
                              <h3 class="text-white mb-1">200+</h3>
                              <p class="text-white">Real Weddings</p>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <!-- /.hero-section -->
</template>
<script>
export default {
  name: "LandingHero",
  props: {
    msg: String
  }
};
</script>
